import React from 'react';
import { Link } from 'react-router';
import AppRoutes from '../../routes/routes';
import { isFeatureEnabled } from '../../constants/features';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import MarketingSubscribe from '../../components/homepage/marketing-subscribe';
import LoginStore from '../../stores/login-store';

export default class MarketingAbout extends React.Component {
  componentDidMount() {
    this.initReveal();
  }

  componentDidUpdate() {
    this.initReveal();
  }

  initReveal() {
    const reveals = document.querySelectorAll('.reveal:not(.visible)');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach(el => io.observe(el));
    } else {
      reveals.forEach(el => el.classList.add('visible'));
    }
  }

  render() {
    return (
      <div className="new-homepage-wrapper">
        <SEOHead {...SEO_CONFIG.about} />

        {/* Header */}
        <div className="section" style={{ paddingTop: 112, textAlign: 'center' }}>
          <div className="eyebrow reveal" style={{ justifyContent: 'center' }}>
            <div className="eyebrow-line"></div>
            <span className="eyebrow-text">About Us</span>
            <div className="eyebrow-line"></div>
          </div>
          <h1 className="section-title reveal reveal-delay-1">
            Neurology knowledge,<br /><em>structured for clinicians</em>
          </h1>
          <p className="section-sub reveal reveal-delay-2">
            NEUROCHECKLISTS is a comprehensive, evidence-based database built to give every clinician fast,
            structured access to practical neurology — at the bedside, in clinic, or during research.
          </p>
        </div>

        {/* Core Features */}
        <div className="section" style={{ paddingTop: 0 }}>
          <div className="feature-grid">
            <div className="feature-card reveal reveal-delay-1">
              <div className="feature-icon">🔍</div>
              <div className="feature-title">Smart Search</div>
              <div className="feature-desc">Search thousands of checklists quickly across practical neurology topics — from presenting symptoms to subspecialty diagnostic criteria.</div>
            </div>
            <div className="feature-card reveal reveal-delay-2">
              <div className="feature-icon">📄</div>
              <div className="feature-title">Fully Referenced</div>
              <div className="feature-desc">Evidence-based and fully referenced. Every checklist item is sourced from established guidelines, review articles, or major studies — all linked directly to their sources.</div>
            </div>
            <div className="feature-card reveal reveal-delay-3">
              <div className="feature-icon">🔖</div>
              <div className="feature-title">Bookmarks &amp; Notes</div>
              <div className="feature-desc">Save your favourite checklists for easy reference. Keep personal notes and reminders on any topic for quick future access.</div>
            </div>
          </div>
        </div>

        {/* Mission */}
        <div className="steps-section">
          <div className="steps-grid-bg"></div>
          <div className="steps-inner">
            <div className="eyebrow reveal" style={{ justifyContent: 'center' }}>
              <div className="eyebrow-line" style={{ background: 'rgba(147,197,253,.5)' }}></div>
              <span className="eyebrow-text">Our Mission</span>
              <div className="eyebrow-line" style={{ background: 'rgba(147,197,253,.5)' }}></div>
            </div>
            <h2 className="section-title reveal reveal-delay-1">Built to solve a real<br /><em>clinical challenge</em></h2>
            <div className="steps-row">
              <div className="step reveal reveal-delay-1">
                <div className="step-num-wrap"><div className="step-num">1</div></div>
                <div className="step-title">Practical at the Point of Care</div>
                <div className="step-desc">Developed to address the challenge of accessing relevant information on a busy ward round or in clinic — a prompt to important but easily overlooked points when taking a history, requesting investigations, or prescribing treatments.</div>
              </div>
              <div className="step reveal reveal-delay-2">
                <div className="step-num-wrap"><div className="step-num">2</div></div>
                <div className="step-title">Comprehensive Coverage</div>
                <div className="step-desc">Covering all neurological and allied subspecialties — including the intersection of neurology and general medicine — to serve every clinician who cares for patients with neurological problems.</div>
              </div>
              <div className="step reveal reveal-delay-3">
                <div className="step-num-wrap"><div className="step-num">3</div></div>
                <div className="step-title">Always Up to Date</div>
                <div className="step-desc">Written and reviewed by consultant neurologist {isFeatureEnabled('authorPage')
                  ? <Link to={AppRoutes.ibrahimImam}>Dr Ibrahim Imam</Link>
                  : 'Dr Ibrahim Imam'} and regularly revised to reflect the latest evidence. Every reference is linked to its PubMed abstract or full online document, so verification is always just a click away.</div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="section" style={{ textAlign: 'center' }}>
          <div className="eyebrow reveal" style={{ justifyContent: 'center' }}>
            <div className="eyebrow-line"></div>
            <span className="eyebrow-text">By the numbers</span>
            <div className="eyebrow-line"></div>
          </div>
          <h2 className="section-title reveal reveal-delay-1">The reference clinicians <em>rely on</em></h2>
          <div className="kpi-row reveal reveal-delay-2">
            <div className="kpi-card">
              <div className="kpi-label">Checklists</div>
              <div className="kpi-value">4,000+</div>
              <div className="kpi-change up">Curated topics</div>
            </div>
            <div className="kpi-card">
              <div className="kpi-label">Guidelines</div>
              <div className="kpi-value">240+</div>
              <div className="kpi-change up">Clinical sources</div>
            </div>
            <div className="kpi-card">
              <div className="kpi-label">Users</div>
              <div className="kpi-value">5,000+</div>
              <div className="kpi-change up">Healthcare professionals</div>
            </div>
            <div className="kpi-card">
              <div className="kpi-label">Subspecialties</div>
              <div className="kpi-value">All</div>
              <div className="kpi-change up">Neurology &amp; allied fields</div>
            </div>
          </div>
        </div>

        {LoginStore.isLoggedIn() ? null : <MarketingSubscribe />}
      </div>
    );
  }
}
